import { useMemo } from 'react';
import { appwriteQueryFns } from '../services/query/appwriteQueryFns';
import type { CampaignMetadata } from '../types';

/**
 * Derives campaign counts from campaigns data.
 * This is NOT a TanStack Query hook - it derives data from useCampaigns.
 * Pass in the campaigns array from useCampaigns().data
 */
export const useCampaignCounts = (campaigns: CampaignMetadata[] | undefined) => {
  return useMemo(() => {
    if (!campaigns || campaigns.length === 0) {
      return { total: 0, campaigns: {} as Record<string, number> };
    }
    return appwriteQueryFns.leads.countsFromCampaigns(campaigns);
  }, [campaigns]);
};
